export enum DrivingRequestVotingConsensusEnum {
  NO_VOTES = 'no_votes',
  SINGLE_VOTE = 'single_vote',
  UNANIMOUS = 'unanimous',
  MAJORITY = 'majority',
  TIE = 'tie',
}

export function getDrivingRequestVotingConsensusLabel(consensus: DrivingRequestVotingConsensusEnum): string {
  switch (consensus) {
    case DrivingRequestVotingConsensusEnum.NO_VOTES:
      return 'No existen votos';
    case DrivingRequestVotingConsensusEnum.SINGLE_VOTE:
      return 'Sin corroboración de otros asistentes';
    case DrivingRequestVotingConsensusEnum.UNANIMOUS:
      return 'Consenso claro';
    case DrivingRequestVotingConsensusEnum.MAJORITY:
      return 'Mayoría simple';
    case DrivingRequestVotingConsensusEnum.TIE:
      return 'Empate entre candidatos';
  }
}

export function getDrivingRequestVotingConsensusChipTone(consensus: DrivingRequestVotingConsensusEnum): 'neutral' | 'positive' | 'warning' {
  switch (consensus) {
    case DrivingRequestVotingConsensusEnum.NO_VOTES:
      return 'warning';
    case DrivingRequestVotingConsensusEnum.SINGLE_VOTE:
      return 'neutral';
    case DrivingRequestVotingConsensusEnum.UNANIMOUS:
      return 'positive';
    case DrivingRequestVotingConsensusEnum.MAJORITY:
      return 'positive';
    case DrivingRequestVotingConsensusEnum.TIE:
      return 'warning';
  }
}
